import * as React from "react"

import {
  saIframe,
  saVideoSliderListItem,
  saVideoSliderListItemContentContainer,
  saVideoSliderListItemName,
  saVideoSliderListItemPosition
  //@ts-ignore
} from "./saVideoSlider.module.scss"
import { saInterfaceVideoSliderItem } from "../saTypes"


export const SaSlideItem:React.FC<saInterfaceVideoSliderItem> = ({ ...props }) => {


    return (
      <div className={saVideoSliderListItem}>

        {
          props.videoUrl &&
          <div className={saIframe}>
            <iframe src={props.videoUrl }/>
          </div>
        }

        {
          props.content &&
          <div className={saVideoSliderListItemContentContainer}
               dangerouslySetInnerHTML={{ __html: props.content }} />
        }

        {
          props.title &&
          <div className={saVideoSliderListItemName}
               dangerouslySetInnerHTML={{ __html: props.title }} />
        }

        {
          props.position &&
          <div className={saVideoSliderListItemPosition}
               dangerouslySetInnerHTML={{ __html: props.position }} />
        }

      </div>
    )

}
